import React, {
  useCallback,
  useMemo,
  useState,
  useEffect,
  useRef,
} from "react";
import { Text, Image, TouchableOpacity, View, FlatList } from "react-native";
import { Ionicons } from "@expo/vector-icons";
import { AppColors } from "../../utility/AppColors";
import { AppFontStyle } from "../../styles/AppFontStyle";
import NoDataFound from "../NoDataFound";
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  useDeviceSize,
} from "rn-responsive-styles";
import { StackActions, useNavigation } from "@react-navigation/native";
import { navigateToScreen } from "../../utility/NavigationHelper";
import { AppScreens } from "../../screens/Utility/AppScreens";
import GameSkeleton from "../skeleton-components/GameSkeleton";
import ImageComponent from "../ImageComponent";
import { AppImages } from "../../utility/AppImages";

export default function BrowsGamesComponent({
  styles,
  eventsResult,
  eventsResultEmpty,
  heading,
  showLoader,
}) {
  const deviceSize = useDeviceSize();
  const navigation = useNavigation();

  const flatListRef = useRef(null);
  const [popularIndex, setPopularIndex] = useState(0);

  const arrGames = useMemo(
    () =>
      eventsResult.map((game) => ({
        title: game.title,
        source: game.source,
      })),
    [eventsResult]
  );

  useEffect(() => {
    if (arrGames.length > 0) {
      flatListRef.current?.scrollToIndex({
        index: popularIndex,
        animated: true,
        viewPosition: 0,
      });
    }
  }, [popularIndex, arrGames]);

  const handleNextPress = () => {
    if (popularIndex < arrGames.length - 1) {
      setPopularIndex(popularIndex + 1);
    }
  };

  const handlePrevPress = () => {
    if (popularIndex > 0) {
      setPopularIndex(popularIndex - 1);
    }
  };

  return (
    <View style={{}}>
      <View
        style={{
          flexDirection: "row",
          justifyContent: "space-between",
          marginTop: 10,
          alignItems: "center",
          marginBottom: 20,
        }}
      >
        <Text
          style={[
            deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
              ? AppFontStyle.BOLD_ANYBODY_16
              : AppFontStyle.BOLD_ANYBODY_24,
            {
              paddingHorizontal:
                deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                  ? "3.5%"
                  : 0,
            },
          ]}
        >
          {heading}
        </Text>
        {deviceSize === DEVICE_SIZES.XS ||
        deviceSize === DEVICE_SIZES.SM ? null : (
          <View style={{ flexDirection: "row", gap: 20 }}>
            <TouchableOpacity
              style={{
                backgroundColor: AppColors.lightBlack,
                borderRadius: 25,
                padding: 6,
                opacity: popularIndex === 0 ? 0.5 : 1, // Visual feedback when disabled
              }}
              onPress={handlePrevPress}
              disabled={popularIndex === 0} // Disable when at the start
            >
              <ImageComponent
                url={AppImages.icArrowLeft}
                style={{
                  height: 24,
                  width: 24,
                }}
              />
            </TouchableOpacity>
            <TouchableOpacity
              style={{
                backgroundColor: AppColors.lightBlack,
                borderRadius: 25,
                padding: 6,
                opacity: popularIndex < arrGames.length - 1 ? 1 : 0.5, // Optional: Disable Next when at the end
              }}
              onPress={handleNextPress}
              disabled={popularIndex >= arrGames.length - 1} // Optional: Disable when at the end
            >
              <ImageComponent
                url={AppImages.icArrowRight}
                style={{
                  height: 24,
                  width: 24,
                }}
              />
            </TouchableOpacity>
          </View>
        )}
      </View>
      {showLoader ? (
        <GameSkeleton />
      ) : (
        <View
          style={{
            marginVertical: 14,
            gap: 5,
          }}
        >
          {eventsResultEmpty ? (
            <View style={{ alignItems: "center", paddingVertical: 20 }}>
              <Text
                style={[
                  AppFontStyle.REGULAR_ANYBODY_14,
                  {
                    color: AppColors.gray_C3C3C3,
                    textAlign: "center",
                    marginBottom: 5,
                  },
                ]}
              >
                No games available at the moment
              </Text>
              <Text
                style={[
                  AppFontStyle.REGULAR_ANYBODY_12,
                  {
                    color: AppColors.gray_A6A3AA,
                    textAlign: "center",
                  },
                ]}
              >
                New games will be added regularly
              </Text>
            </View>
          ) : (
            <View style={{ flexDirection: "row", alignItems: "center" }}>
              <FlatList
                ref={flatListRef}
                data={arrGames}
                horizontal
                scrollEnabled
                showsHorizontalScrollIndicator={false}
                keyExtractor={(item, index) => String(item.title)}
                renderItem={({ item, index }) => {
                  return (
                    <TouchableOpacity
                      style={[
                        {
                          marginLeft: index === 0 ? 20 : 0,
                          marginRight: arrGames.length === index ? 20 : 0,
                          alignItems: "center",
                        },
                      ]}
                      activeOpacity={0.8}
                      onPress={() => {
                        navigateToScreen(navigation, AppScreens.SearchGameWebScreen, {
                            game: item.title,
                          });
                      }}
                    >
                      <View
                        style={[
                          {
                            overflow: "hidden",
                            width: 115,
                          },
                        ]}
                      >
                        <Image
                          source={item.source}
                          style={{
                            width: 110,
                            height: 128,
                            borderRadius: 12,
                          }}
                          resizeMode="cover"
                        />
                      </View>
                      <Text
                        style={[
                          AppFontStyle.MEDIUM_ANYBODY_14,
                          {
                            color: AppColors.white,
                            marginTop: 10,
                            width: 100,
                            textAlign: "center",
                          },
                        ]}
                      >
                        {item.title}
                      </Text>
                    </TouchableOpacity>
                  );
                }}
                ItemSeparatorComponent={() => <View style={{ width: 24 }} />}
                style={{
                  height: 185,
                }}
              />
            </View>
          )}
        </View>
      )}
    </View>
  );
}
